<template>
  <header>
    <div class="header-nav">
      <a href="/" class="header-nav__logo-prodemos"><img src="@/assets/ProDemos_logo_full.svg"/></a>
      <a href="/" class="header-nav__logo-demoinactie"><img src="@/assets/logo-democratie-in-actie.png" /></a>
      <div class="header-nav__links">
        <router-link :to="{ name: 'startscherm' }">Start</router-link>
        <router-link :to="{ name: 'paginacontent', params: { p: '9' } }">Over de ParticipatieWijzer</router-link>
        <router-link :to="{ name: 'paginacontent', params: { p: '11' } }">Over ProDemos</router-link>
      </div>
      <h1 class="header-nav__title">{{ titel }}</h1>
      <a href="https://prodemos.nl" class="header-nav__logo-right"><img src="@/assets/ProDemos_logo_small.svg"/></a>
    </div>
  </header>
</template>

<script>
export default {
  name: "mainNav",

  props: {
    titel: String,
  },

  computed: {

  },

  methods: {

  },

  mounted() {
  }
};
</script>

